// Module
var code = "<p>賃借および担保のレベルを調整すれば{debt}のマージンポジションを更新できます。</p> <p>担保比率がメンテナンス担保比率である{mr}を超えている限り、担保および賃借のレベルは任意に調整できます。<a href=\"/borrow\">もっと知る</a></p> ";
// Exports
export default code;